module.exports = __webpack_public_path__ + "img/BF-brand-grey.14f83f20.svg";